<app-loader [Parent]="this"></app-loader>
<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Add User</p>
        </header>
        <form [formGroup]="Form">
            <section class="modal-card-body" style="min-width: 800px;">
                
                <app-field Label="First Name">
                    <div class="control">
                        <input type="text" id="firstname" class="input" formControlName="firstName"
                            placeholder="First Name">
                        <app-validator [For]="Form.get('firstName')"></app-validator>
                    </div>
                </app-field>

                <app-field Label="Last Name">
                    <div class="control">
                        <input type="text" class="input" formControlName="lastName"
                            placeholder="Last Name">
                        <app-validator [For]="Form.get('lastName')"></app-validator>
                    </div>
                </app-field>

                <app-field Label="Email">
                    <div class="control">
                        <input type="text" class="input" formControlName="email"
                            placeholder="Email Address">
                        <app-validator [For]="Form.get('email')"></app-validator>
                    </div>
                </app-field>
            </section>


            <footer class="modal-card-foot">
                <app-form-save-button [Parent]="this" [Form]="Form" (OnSave)="addUser()" [ButtonContext]="'Add User'" [Icon]="'plus'"></app-form-save-button>
                <button class="button ml-3" (click)="cancel()">Cancel</button>
            </footer>

        </form>
    </div>

</div>